import {createSlice} from '@reduxjs/toolkit';
import {closePreferredBuildingSelection, openPreferredBuildingSelection, selectPreferredBuilding} from './actions';
import {UIProfileState} from './types';

const initialState: UIProfileState = {
  selectedBuildingId: '',
  originalBuildingId: '',
  isDirty: false,
  isSavingBuilding: false,
};

const slice = createSlice({
  name: 'ui/profile',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(openPreferredBuildingSelection, (state, action) => {
        state.originalBuildingId = action.payload;
        state.selectedBuildingId = action.payload;
      })
      .addCase(selectPreferredBuilding, (state, action) => {
        state.selectedBuildingId = action.payload;
        state.isDirty = action.payload !== state.originalBuildingId;
      })
      .addCase(closePreferredBuildingSelection, (state) => {
        state.originalBuildingId = '';
        state.selectedBuildingId = '';
        state.isDirty = false;
      });
  },
});

export const {reducer: profileReducer} = slice;
